import { CanvasIconTypes } from '@workday/design-assets-types';
var icon = {
    name: 'caretDown',
    type: CanvasIconTypes.System,
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="wd-icon-caret-down wd-icon" focusable="false" role="presentation" viewBox="0 0 24 24"><g fill-rule="evenodd" class="wd-icon-container"><path d="M11.727 16.59c.15.226.398.222.546 0l5.454-8.18c.15-.226.044-.41-.227-.41h-11c-.276 0-.375.188-.227.41z" class="wd-icon-fill"/></g></svg>',
    filename: 'wd-icon-caret-down.svg',
    category: 'Core',
    tags: ['navigation', 'arrow', 'triangle', 'data', 'table', 'grid'],
};
export default icon;
